export const getColumns: any = [
  {
    title: 'Participant Name',
    field: 'participantCode',
    headerStyle: { zIndex: 11 },
    width: '15%'
  },
  {
    title: 'Company Name',
    field: 'companyName',
    headerStyle: { zIndex: 11 },
    width: '10%'
  }
];

export default getColumns;
